import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { authService, AuthUser } from './services/authService';
import AuthPage from './pages/AuthPage';
import MainPage from './pages/MainPage';
import './index.css';

function App() {
  const [user, setUser] = useState<AuthUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = authService.onAuthStateChanged((authUser: AuthUser | null) => {
      setUser(authUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center" style={{ background: 'var(--main-background)' }}>
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 mx-auto mb-4" style={{ borderColor: 'var(--brand-teal)' }}></div>
          <p style={{ color: 'var(--medium-gray)' }}>載入中...</p>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <div className="h-screen overflow-hidden" style={{ background: 'var(--main-background)' }}>
        <Routes>
          <Route 
            path="/auth" 
            element={user ? <Navigate to="/" replace /> : <AuthPage />} 
          />
          <Route 
            path="/" 
            element={user ? <MainPage /> : <Navigate to="/auth" replace />} 
          />
          <Route 
            path="*" 
            element={<Navigate to={user ? "/" : "/auth"} replace />} 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
